<template>
  <div class="bar-follow">
    <div class="course">
      <img class="logo" src="../assets/logo.png" alt />
      <div class="course-name">{{ wechat }}</div>
    </div>
    <img v-show="isShowHand" class="hand-arrow" src="../assets/hand.svg" alt />
    <BtnFollow @click.native="$emit('follow')"></BtnFollow>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import BtnFollow from './BtnFollow.vue';
@Component({
  components: {
    BtnFollow,
  },
})
export default class BarFollow extends Vue {
  @Prop({ type: Boolean }) isShowHand!: boolean;
  @Prop({ type: String, default: 'Python 小课' }) wechat!: string;
}
</script>

<style lang="scss" scoped>
@keyframes poky {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-30px);
  }
  100% {
    transform: translateY(0);
  }
}
.bar-follow {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .course {
    display: flex;
    align-items: center;
    color: #3c3838;
    font-weight: 500;
    font-size: 34px;
    .logo {
      width: 90px;
      height: 90px;
      margin-right: 10px;
    }
  }
  .hand-arrow {
    position: absolute;
    top: -100px;
    right: 30px;
    width: 100px;
    height: 100px;
    animation: poky 0.4s ease-in infinite;
  }
}
</style>
